import React, { ReactNode } from 'react'
import { ProductCustomizationCardTitle, ProductCustomizationCardWrapper } from './styled'

interface ProductCustomizationCardProps {
  children: ReactNode
  index: number
}

export const ProductCustomizationCard = ({ children, index }: ProductCustomizationCardProps) => {
  return (
    <ProductCustomizationCardWrapper>
      <ProductCustomizationCardTitle>
        ¡No te olvides de personalizar tu <span>Botella {index} de 500ml</span> Coca-Cola original!
      </ProductCustomizationCardTitle>
      {children}
    </ProductCustomizationCardWrapper>
  )
}
